import {useState, useEffect} from 'react';
import Keycloak from 'keycloak-js';

const useKeycloakConfig = () => {
    const [keycloak, setKeycloak] = useState(null);

    useEffect(() => {
        const loadKeycloakConfig = async () => {
            try {
                const response = await fetch('/config/keycloak-config.json');

                if (!response.ok) {
                    throw new Error('Failed to load Keycloak configuration');
                }

                const config = await response.json();
                const keycloakInstance = new Keycloak(config);
                setKeycloak(keycloakInstance);
            } catch (err) {
                console.error('Keycloak config error : ', err);
            }
        };

        loadKeycloakConfig();
    }, []);

    return keycloak;
};

export default useKeycloakConfig;